import { AUTH_HEADER } from '@/core/constants/http-headers'
import { dateService } from '@/core/services/date'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { currencyResolver } from '@/features/currencies/resolvers/currency.resolver'
import { BookFormModel } from '@/features/reservation/types/models/book-form.model'
import { TripInfoResponse } from '../types/api-responses/trip-info-response'
import { TripInfoModel } from '../types/models/trip-info.model'

export function createGetTripInfoUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (tripInfo: BookFormModel) {
    const req = inputToJson(tripInfo)
    const { token, accountType } = await tokenService.getToken()
    const authHeader = token ? AUTH_HEADER(token) : {}
    const res = await httpClient
      .version('v1')
      .addHeaders(authHeader)
      .post<{ data: TripInfoResponse }>(`/website/${accountType}/tripInfo`, req)

    return resolver(res.data.data)
  }
}

function inputToJson(trip: BookFormModel) {
  return {
    checked_luggage: trip.checkedLuggage,
    country_id: trip.countryId,
    hand_luggage: trip.handLuggage,
    from_point_lat: trip.fromPointLat.toString(),
    from_point_long: trip.fromPointLong.toString(),
    from_point_name: trip.fromPointName,
    from_point_details: trip.fromPointDetails,
    passengers: trip.passengers,
    to_point_lat: trip.toPointLat.toString(),
    to_point_long: trip.toPointLong.toString(),
    to_point_name: trip.toPointName,
    to_point_details: trip.toPointDetails,
    booster: trip.booster,
    carrier: trip.carrier,
    child_seat: trip.childSeats,
    date:
      trip.date instanceof Date
        ? dateService.dateToYyMmDd(trip.date)
        : trip.date,
    time:
      trip.time instanceof Date ? dateService.timeToHI(trip.time) : trip.time,
  }
}

function resolver(trip: TripInfoResponse): TripInfoModel {
  return {
    vehicleSize: trip.vehicleSize,
    discount: trip.discount,
    totalPrice: trip.total_price,
    price: trip.price,
    listVehicle: trip.listVehicle.map(({ total_price, ...rest }) => ({
      ...rest,
      totalPrice: total_price,
    })),
    currency: currencyResolver([trip.currency])[0],
  }
}
